import {Component, Injector, OnDestroy, ViewChild} from '@angular/core';
import {ModalComponent} from '@components/modal/modal.component';
import {EquipmentCardInterfaces, EquipmentEnums, EquipmentInterfaces} from '@namespaces/equipment.namespace';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {CardApiService} from '../../services/card.api.service';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {DataEventsService} from '@services/data-events.service';

@Component({
    selector: 'app-card-form-modal',
    templateUrl: 'card-form-modal.component.html'
})

export class CardFormModalComponent extends FrontendFormComponent implements OnDestroy {
    public card: EquipmentCardInterfaces.Card.ItemView;

    @ViewChild(ModalComponent) modal: ModalComponent;

    public equipment: EquipmentInterfaces.Model;

    public types = EquipmentEnums.Type;

    public canEditCalibrations = false;

    constructor(
        injector: Injector,
        public formService: CardApiService,
        private authService: AuthService,
        private dataEvents: DataEventsService,
    ) {
        super(injector);
    }

    init() {
        this.form = this._fb.group({
            id: [''],
            apparatus_id: [''],
            responsible_employee_id: [''],
            calibrations: this._fb.array([]),
            equipments: this._fb.array([]),
            repairs: this._fb.array([]),
            places: this._fb.array([])
        });

        if (this.card && this.card.apparatus) {
            this.equipment = {...this.card.apparatus} as EquipmentInterfaces.Model;
        }

        const values: EquipmentCardInterfaces.Card.ItemView = {...this.card};
        delete values.apparatus;

        this.setFormValues(values, this.form);

        this.canEditCalibrations = this.authService.hasPermissions([
            UserNamespace.Permission.equipmentCardCalibrationAdd,
            UserNamespace.Permission.equipmentCardCalibrationUpdate,
        ]);
    }

    show() {
        this.modal.open();
    }

    onModalClose() {
        /**
         * Метод переопределяется тем компонентом, который динамически создает текущий
         */
    }

    afterSave() {
        const id = this.form.get('id').value;
        this.dataEvents.equipmentCardUpdate$.next(id);
        this.isPending = false;
        this.modal.close();
    }

    ngOnDestroy() {

    }
}
